<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Networks from './networks'
import AddEdit from './addedit_networks'

import axios from 'axios'

export default {
	page: {
		title: 'All Networks',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, AddEdit, Networks },
	data() {
		return {
			title: 'All Networks',
			category: 'List',
      newTag: null,
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'All Networks',
					active: true,
				},
			],
      network: {
		company: null,
        location: null,
        vlan: null,
        network: null,
        tags: []
      },
      tagsOptions: [
          "Dangerous",
          "In review",
          "Changed",
      ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
    }
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {
	  createNewNetwork () {
      let that = this
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios.post(`${baseURL}/networks/create`, that.network).then(response => {
        console.log('response', response)
      }).catch(e => {
        console.log(e);
      });
    },
    newnetwork () {
      this.$refs.addEditComponent.showModal()
    },
    addNewTag() {
      this.network.tags.push(this.newTag)
      this.tagsOptions.push(this.newTag)
    },
	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
  <div>
	<Layout>
		<PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-xl-2 col-lg-3 col-6">
                <img src="@assets/images/maintenance.svg" class="mr-4 align-self-center img-fluid " alt="cal">
              </div>
              <div class="col-xl-10 col-lg-9">
                <div class="mt-4 mt-lg-0">
                  <h4 class="mt-0 mb-1">Welcome to Networks</h4>
                  <p class="text-muted mb-2">Here you will find, edit and create networks related to Corona Group companies.</p>
                  <button class="btn btn-primary mt-2 mr-1" @click="newnetwork"><i class="uil-plus-circle"></i> Create New Network</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<networks :url="'/data/networks/list?withid=yes&limit=100'" />
					</div>
				</div>
			</div>
		</div>
	</Layout>
  <AddEdit
      :title="'Create New Network'"
      :operation="'create'"
      ref="addEditComponent"
  />
  </div>
</template>
